module.exports = __webpack_public_path__ + "static/img/job-description-generator-icon-and-name.62016bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/job-description-generator-icon-and-name.png
// module id = VMTN
// module chunks = 0